import { FieldMapper } from '@/modules/common/utils/entity-changes-manager';

import { Project } from '../types/projects.types';

export interface ProjectFieldValues {
  name: string;
  clientId: string;
}

/**
 * Field mapper implementation for Project entities.
 * Tracks name and clientId changes for the EntityChangesManager.
 */
export class ProjectFieldMapper implements FieldMapper<Project, ProjectFieldValues> {
  getFieldValue(project: Project, field: keyof ProjectFieldValues): string {
    switch (field) {
      case 'name':
        return project.name;
      case 'clientId':
        return project.client?.id?.toString() ?? '';
      default:
        throw new Error(`Unknown field: ${String(field)}`);
    }
  }

  getTrackableFields(project: Project): ProjectFieldValues {
    return {
      name: project.name,
      clientId: project.client?.id?.toString() ?? '',
    };
  }
}
